import { IconPlayerPlay, IconRefresh } from '@tabler/icons-react';
import React from 'react';
import { BasicActionIcon } from 'src/design/atoms/BasicActionIcon';

export interface IReplyRetryActionsProps {
  onRegenerate?: () => void;
  /** Omit to hide Continue. */
  onContinue?: () => void;
}

/** @registry Regenerate and Continue icon buttons for the action row of the latest assistant reply; Continue renders only when given onContinue. */
export const ReplyRetryActions: React.FC<IReplyRetryActionsProps> = ({
  onRegenerate,
  onContinue,
}) => (
  <>
    <BasicActionIcon
      size="sm"
      variant="subtle"
      color="gray"
      label="Regenerate"
      onClick={onRegenerate}
    >
      <IconRefresh size={16} />
    </BasicActionIcon>
    {onContinue && (
      <BasicActionIcon
        size="sm"
        variant="subtle"
        color="gray"
        label="Continue"
        onClick={onContinue}
      >
        <IconPlayerPlay size={16} />
      </BasicActionIcon>
    )}
  </>
);
